import React from "react";

import { getValue } from "../lib/helper";
import { clsx } from "clsx";
import { Mag } from "ui-svgs";

type Props = {
  inputRef?: any;
  type: "text" | "number" | "password" | "search" | "tel" | "url" | "email" | "file";
  label?: string;
  value?: string | number;
  dirty?: any;
  defaultValue?: any;
  id?: string;
  name?: string;
  inline?: boolean;
  rounded?: boolean;
  required?: boolean;
  currency?: boolean;
  placeholder?: string;
  onChange?: (e: any) => void;
  getVState?: (v: string) => void;
  error?: boolean;
  errorString?: string;
  disabled?: boolean;
  className?: string;
  autoComplete?: string;
};

const Input = ({
  inputRef,
  type,
  label,
  value,
  dirty,
  defaultValue,
  id,
  name,
  placeholder,
  onChange,
  getVState,
  errorString,
  inline,
  rounded,
  required,
  currency,
  error,
  disabled,
  className,
  autoComplete,
  ...props
}: Props) => (
  <div className={clsx({ "form-element": true, inline })} ref={inputRef}>
    {label && <label htmlFor={id}>{label}</label>}
    <div
      className={clsx({
        "form-control-container": true,
        search: type === "search",
        currency: currency,
        [`${className ? className : ""}`]: className,
      })}
    >
      {type === "search" && <Mag />}

      <input
        {...props}
        className={clsx({
          "form-control": true,
          rounded: rounded,
          error: error,
          disabled: disabled,
        })}
        autoComplete={autoComplete}
        onChange={onChange}
        value={getValue(value)}
        defaultValue={defaultValue}
        type={type || "text"}
        name={name}
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
      />

      {error && errorString && <span className="input-error">{errorString}</span>}
    </div>
  </div>
);

export default Input;
